var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.35147L7.02451 0.175736C7.24767 -0.0585787 7.60948 -0.0585787 7.83263 0.175736C8.05579 0.410051 8.05579 0.78995 7.83263 1.02426L4.40406 4.62426C4.1809 4.85858 3.8191 4.85858 3.59594 4.62426L0.167367 1.02426C-0.055789 0.789949 -0.055789 0.41005 0.167367 0.175736C0.390524 -0.058579 0.752332 -0.058579 0.975489 0.175736L4 3.35147Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.15147L7.02451 4.97574C7.24767 4.74142 7.60948 4.74142 7.83263 4.97574C8.05579 5.21005 8.05579 5.58995 7.83263 5.82427L4.40406 9.42427C4.1809 9.65858 3.8191 9.65858 3.59594 9.42427L0.167367 5.82427C-0.055789 5.58995 -0.055789 5.21005 0.167367 4.97574C0.390524 4.74142 0.752332 4.74142 0.975489 4.97574L4 8.15147Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.301f24654afb4383594dc63508977f7a.svg";
export { ForwardRef as ReactComponent };